<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                
                <div class="row align-items-start">
                    <div class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      2
                    </div>
                    <div class="col loa-lab-steps">
                      3
                    </div>
                    <div class="col loa-lab-steps">
                      4
                    </div>
                  </div>
                <div class="row justify-content-center loa-form">
                    <div class="login-form">
                        <p class="h4">WHAT WAS YOUR DIAGNOSIS FROM THE DOCTOR?</p>
                        <div class="mb-3">
                            <label for="exampleFormControlTextarea1" class="form-label"></label>
                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                          </div>
                    </div>
                       <div class="col-md-12 member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="/loa-lab">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg"><router-link to="/loa-lab-3">NEXT</router-link></button>
            </div>
                </div>
        </div>
            </div>
        </section>
</body>
</template>


<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: []


    }
  },
  methods: {
    async handleSearch() {
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName
        }, 
        );

        console.log(response);
        this.Doctors=response.data

        
        
    }
    
  }
  }



</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
